export default __webpack_public_path__ + "navigation-examples-custom-segue-960-cb9436317ba66623967ac826d206d731.png";